
export default [
	{ name: "Mkpasswd", path: "/mkpasswd" },
	{ name: "GridCalc", path: "/gridcalc" },
	{ name: "RatioCalc", path: "/ratiocalc" },
	{ name: "DataURI", path: "/datauri" },
	{ name: "AsciiTree", path: "/asciitree" },
	{ name: "MultiMentions", path: "/multimentions" },
	{ name: "Zen2Han", path: "/zen2han" },
];



// WEBPACK FOOTER //
// ./src/js/json/apps.js